import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { Container } from '../components/Container'
import { Heading } from '../components/Heading'
import { JobsList } from '../components/JobsList'
import { Section } from '../components/Section'

interface JobsProps {
  limit?: number | undefined
}

export const Jobs = ({ limit }: JobsProps) => {
  const { jobs } = useStaticQuery<Queries.JobsSectionQuery>(graphql`
    query JobsSection {
      jobs: allWpJob {
        nodes {
          id
          title
          slug
          excerpt
        }
      }
    }
  `)
  const jobsNodes = limit ? jobs.nodes.slice(0, limit) : jobs.nodes

  return (
    <Section>
      <Container>
        <div className="grid gap-8">
          <Heading as="h1">Volné pozice</Heading>

          <JobsList jobs={jobsNodes} />
        </div>
      </Container>
    </Section>
  )
}
